/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $) {
	'use strict';

	/**
	 * Flyout module implementation.
	 *
	 * @author
	 * @namespace Tc.Module
	 * @class Flyout
	 * @extends Tc.Module
	 */
	Tc.Module.Flyout = Tc.Module.extend({
		on: function(callback) {
			var mod = this;

			mod.closeCallbacks = [];

			mod.createClickAwayHandler();

			mod.$ctx.on('scsh-flyout-open', function(event, closeCallback) {
				if(closeCallback) {
					mod.registerCloseCallback(closeCallback);
				}
				mod.openFlyout();
			});
			mod.$ctx.on('scsh-flyout-close', function() { mod.closeFlyout(); });

			mod.$panel = mod.$ctx.find('.scsh-flyout-panel');
			callback();
		},

		createClickAwayHandler : function () {
			var mod = this,
				$ctx = mod.$ctx;

			this.bodyClickAwayFlyout = function(e) {
				if (mod.$panel.is(e.target) ||
					$.contains(mod.$panel[0], e.target)) {
					return;
				}
				if($ctx.is('.scsh-flyout-open')) {
					mod.closeFlyout();
				}
			};
			this.bodyEscAwayFlyout = function(e) {
				if (e.which === 27 && $ctx.is('.scsh-flyout-open')) { // ECS key
					mod.closeFlyout();
				}
			};
		},

		registerCloseCallback : function(cb) {
			this.closeCallbacks.push(cb);
		},

		openFlyout : function() {
			var mod = this,
				$ctx = mod.$ctx;

			if (!$ctx.is('.scsh-flyout-open')) {

				$ctx.addClass('scsh-flyout-open');
				setTimeout(function() { $ctx.addClass('scsh-flyout-open-anim'); }, 1);
				setTimeout(function() {
					$('body').on('click', mod.bodyClickAwayFlyout);
					$('body').on('keydown', mod.bodyEscAwayFlyout);
				}, 0);
			}
		},

		closeFlyout : function() {
			var mod = this,
				$ctx = mod.$ctx;

			$('body').off('keydown', mod.bodyEscAwayFlyout);
			$('body').off('click', mod.bodyClickAwayFlyout);

			$ctx.removeClass('scsh-flyout-open-anim');
			$ctx.removeClass('scsh-flyout-open');

			for(var i = 0; i < mod.closeCallbacks.length; i+=1) {
				mod.closeCallbacks[i]();
			}
			mod.closeCallbacks = [];
		}
	});
}(window.Tc, window.scsHeaderJQuery));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/responsive/js/modules/Tc.Module.Flyout.js
// module id = 360
// module chunks = 0